module.exports = __webpack_public_path__ + "static/media/44.98286a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/44.jpg
// module id = 577
// module chunks = 0